import styles from "@hub/ui/cards/document-card.module.css";
import { Tag } from "@hub/ui/tags/tag";
import { ThemeColors } from "@hub/values/theme-colors.enum";
import React from "react";

interface DocumentCardHeadlineProps {
  title: string;
  description: string;
  singleLineTitle?: boolean;
  external?: boolean;
  hasRabbit?: boolean;
}

export const DocumentCardHeadline: React.FC<DocumentCardHeadlineProps> = ({
  title,
  description,
  singleLineTitle,
  external,
  hasRabbit,
}) => {
  const titleParts = title.split(":");
  let preTitle = titleParts[0];
  let postTitle = titleParts[1];

  if (singleLineTitle && preTitle && postTitle) {
    preTitle = `${preTitle}: ${postTitle}`;
    postTitle = undefined;
  }

  return (
    <div className={styles.headline}>
      <div className={styles.headline__titleContainer}>
        {preTitle && !postTitle && (
          <span className={styles.headline__title}>
            {title}
            {hasRabbit && (
              <img
                className={styles.paws}
                src="/resources/assets/paws.svg"
                alt="animal footprints"
              />
            )}
          </span>
        )}
        {preTitle && postTitle && (
          <>
            <span className={styles.headline__title}>{preTitle.trim()}:</span>
            <span className={styles.headline__title}>
              {postTitle.trim()}
              {hasRabbit && (
                <img
                  className={styles.paws}
                  src="/resources/assets/paws.svg"
                  alt="animal footprints"
                />
              )}
            </span>
          </>
        )}
      </div>
      {external && (
        <div className={styles.headline__external}>
          <Tag tag="External Resource" themeColor={ThemeColors.PINK} />
        </div>
      )}
      <span className={styles.headline__description}>{description}</span>
    </div>
  );
};
